import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=0190aff0&"
import script from "./TheModal.vue?vue&type=script&lang=js&"
export * from "./TheModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0190aff0')) {
      api.createRecord('0190aff0', component.options)
    } else {
      api.reload('0190aff0', component.options)
    }
    module.hot.accept("./TheModal.vue?vue&type=template&id=0190aff0&", function () {
      api.rerender('0190aff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/TheModal.vue"
export default component.exports